import { FunctionComponent } from 'react'
import classNames from 'classnames'
import { ProductCardCollapsedPriceProps } from './ProductCardCollapsedPrice.types'
import { useMealActions } from 'src/hooks/coreUx/useMealActions'
import './ProductCardCollapsedPrice.scss'

export const ProductCardCollapsedPrice: FunctionComponent<ProductCardCollapsedPriceProps> = ({
  className = '',
  product
}) => {
  const { priceText } = useMealActions(product, undefined, undefined)

  return (
    <div
      className={classNames('core-ux-product-card-collapsed-price', className)}>
      {priceText}
    </div>
  )
}
